import * as Sentry from '@sentry/browser';
import SENTRY_CONFIG from './SentryCommonConfig';

Sentry.init(SENTRY_CONFIG);
